module.exports = __webpack_public_path__ + "img/google-play-badge.ef036a60.png";